<template>
    <div class="newsletter">
        <div class="container">
            <h2>Cadastre-se em nossa newsletter</h2>
            <p class="texto">
                Receba informações sempre atualizadas e fique por dentro das
                novidades da UGT-SP
            </p>
            <form class="newsletter__form">
                <input type="text" placeholder="E-mail" v-model="email" />
                <button class="btn-form" @click.prevent="submitNewsLetter">
                    Enviar
                </button>
            </form>
            <p>
                <span class="text-xs"> Nós respeitamos sua privacidade</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "newsletter",
    data() {
        return {
            email: ""
        };
    },
    methods: {
        submitNewsLetter() {
            let data = {
                email: this.email
            };
            this.axios
                .post("newsletter", data)
                .then(response => {
                    this.$swal({
                        title: "Sucesso",
                        text: "Seu e-mail foi cadastrado com sucesso",
                        icon: "success"
                    });
                    this.email = "";
                })
                .catch(error => {
                    console.log(error);
                });
        }
    }
};
</script>

<style scoped lang="scss">
.newsletter {
    background: linear-gradient(
            to right,
            rgba(0, 0, 0, 0.4),
            rgba(0, 0, 0, 0.9)
        ),
        url("../../../../../img/bg/bandeirasaopaulo.jpg") no-repeat 0px 10%;
    background-size: cover;
    @apply w-full mx-auto bg-dark-gray mt-10 flex flex-col items-center justify-between text-center h-auto text-white;
    border-radius: 10px;
    max-width: 1280px;
    .container {
        @apply py-10 px-2;
    }
    @media (max-width: 768px) {
        form {
            @apply flex  flex-col items-center justify-between mx-auto my-5 max-w-xs;
            input {
                @apply w-full py-2 px-2 text-black rounded-lg;
            }
        }
        h2 {
            @apply font-bold py-2 text-2xl;
        }
        .btn-form {
            @apply w-full mt-4 bg-primary w-full text-white py-3 mx-2 text-xs italic rounded-lg;
        }
        .texto {
            @apply w-full mx-auto font-medium;
        }
    }
    @media (min-width: 880px) {
        form {
            @apply flex items-center justify-between mx-auto my-5 max-w-lg;
            input {
                @apply py-3 px-5 text-black text-sm rounded-lg;
                width: 70%;
            }
            input:focus {
                outline: none;
            }
        }
        h2 {
            @apply font-bold py-2 text-4xl;
        }
        .btn-form {
            @apply bg-primary text-white py-3 ml-2 text-sm italic rounded-lg;
            width: 30%;
        }
        .btn-form:hover {
            background-color: #920002;
        }
        .btn-form:focus {
            outline: none;
        }
        .texto {
            @apply w-1/2 mx-auto font-medium;
        }
    }
    @media (min-width: 1024px) {
        .texto {
            @apply w-1/3 mx-auto font-medium;
        }
    }
}
</style>
